import type { Locale } from "@/lib/i18n";
import { pl, type CCategoryAdvertisementTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cCategoryAdvertisementTranslations: Record<Locale, CCategoryAdvertisementTranslations> = {
  pl,
  en,
  de,
};

export type { CCategoryAdvertisementTranslations };
